export enum FavIcon {
    iconePortailIris = 'assets/images/favicon/favicon-iris.ico',
    iconePortailChantier = 'assets/images/favicon/favicon.png',
}
